import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { OptionPersonalLedgerView, RptOptionPersonalLedgerView } from 'src/models/rptOptionPersonalLedgerView';
import { VestingMaster } from 'src/models/acceptofferDetail';

//================|| OPTION PERSONAL LEDGER SLICE ||=================//
type OptionPersonalLedgerState = {
    loading: boolean;
    error: ErrorInformation;
    optionPersonalLedgerView: OptionPersonalLedgerView;
    rptOptionPersonalLedgerView: RptOptionPersonalLedgerView;
    vestingMaster: VestingMaster;
}

type GrantNoAndID = {
    grantNo: string,
    userID: string
}

const initialState: OptionPersonalLedgerState = {
    loading: true,
    error: null,
    optionPersonalLedgerView: {
        plans: [],
        fullName: '',
        nric: '',
    },
    rptOptionPersonalLedgerView: null,
    vestingMaster: null
};

export const getOptionPersonalLedgerView = createAsyncThunk<OptionPersonalLedgerView, {}, { rejectValue: ErrorInformation }>(
    "optionPersonalLedger/getOptionPersonalLedgerView",
    async ({ }, { rejectWithValue }) => {
        try {
            const optionPersonalLedgerViewResponse = await axios.get<OptionPersonalLedgerView>('MyOption/GetPersonalLedgerView');
            return optionPersonalLedgerViewResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getRptOptionPersonalLedgerView = createAsyncThunk(
    "optionPersonalLedger/getRptOptionPersonalLedgerView",
    async (planID: number, { rejectWithValue }) => {
        try {
            const rptOptionPersonalLedgerViewResponse = await axios.get<RptOptionPersonalLedgerView>(`MyOption/GetPersonalLedger?planID=${planID}`)
            return rptOptionPersonalLedgerViewResponse['data']
        } catch (error) {
            return errorHandler(error)
        }
    }
)

export const getVestingSchedule = createAsyncThunk(
    "performanceViewAwardDetail/getVestingSchedule",
    async (grantNoAndID: GrantNoAndID, { rejectWithValue }) => {
        try {
            const getVestingScheduleResponse = await axios.get<VestingMaster>(`Misc/getOptionVestingSchedule?GrantNo=${grantNoAndID.grantNo}&GrantUserID=${grantNoAndID.userID}`)
            return getVestingScheduleResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

const optionPersonalLedgerSlice = createSlice({
    name: 'optionPersonalLedger',
    initialState,
    reducers: {},
    extraReducers: {
        //get Option Personal Ledger View
        [getOptionPersonalLedgerView.pending.type]: (state) => {
            state.loading = true;
        },
        [getOptionPersonalLedgerView.fulfilled.type]: (state, action) => {
            state.optionPersonalLedgerView = action.payload;
            state.loading = false;
        },
        [getOptionPersonalLedgerView.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        //get Vesting Schedule
        [getVestingSchedule.pending.type]: (state) => {
            state.loading = true;
        },
        [getVestingSchedule.fulfilled.type]: (state, action) => {
            state.vestingMaster = action.payload;
            state.loading = false;
        },
        [getVestingSchedule.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Rpt Option Personal Ledger View
        [getRptOptionPersonalLedgerView.pending.type]: (state) => {
            state.loading = true;
        },
        [getRptOptionPersonalLedgerView.fulfilled.type]: (state, action) => {
            state.rptOptionPersonalLedgerView = action.payload;
            state.loading = false;
        },
        [getRptOptionPersonalLedgerView.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
    }
})
export default optionPersonalLedgerSlice